import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Terms of Service" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="hero-content"
            >
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <span>Terms of Service</span>
              </div>
              <h1>Terms of Service</h1>
              <p>Please read these terms carefully before using our services.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="legal-document"
            >
              <div className="document-header">
                <h2>Terms of Service for Efficient Group</h2>
                <p className="last-updated">Last updated: December 2024</p>
              </div>

              <div className="document-content">
                <section className="legal-section">
                  <h3>1. Acceptance of Terms</h3>
                  <p>By accessing and using Efficient Group's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
                </section>

                <section className="legal-section">
                  <h3>2. Services Description</h3>
                  <p>Efficient Group provides comprehensive facilities management services including:</p>
                  <ul>
                    <li>Industrial Design for Kitchen & Laundry Equipment</li>
                    <li>MEP Executive Drawings and Engineering Services</li>
                    <li>Professional Training Sessions for Operators</li>
                    <li>After-Sale Service and Maintenance Support</li>
                    <li>Equipment Installation and Repair Services</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>3. Service Agreements</h3>
                  <p>All services are subject to separate service agreements that will specify:</p>
                  <ul>
                    <li>Scope of work and deliverables</li>
                    <li>Timeline and milestones</li>
                    <li>Payment terms and conditions</li>
                    <li>Warranty and support provisions</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>4. Payment Terms</h3>
                  <p>Payment terms will be specified in individual service contracts. Generally:</p>
                  <ul>
                    <li>Invoices are due within 30 days of receipt</li>
                    <li>Late payments may incur additional charges</li>
                    <li>Services may be suspended for non-payment</li>
                    <li>All prices are subject to applicable taxes</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>5. Intellectual Property</h3>
                  <p>All designs, drawings, specifications, and documentation created by Efficient Group remain our intellectual property unless otherwise agreed in writing. Clients receive usage rights as specified in service agreements.</p>
                </section>

                <section className="legal-section">
                  <h3>6. Warranties and Disclaimers</h3>
                  <p>We warrant that our services will be performed in a professional manner consistent with industry standards. However:</p>
                  <ul>
                    <li>We make no warranties regarding third-party equipment or materials</li>
                    <li>Client modifications to our designs void related warranties</li>
                    <li>Force majeure events are excluded from warranty coverage</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>7. Limitation of Liability</h3>
                  <p>Our liability is limited to the value of services provided. We are not liable for:</p>
                  <ul>
                    <li>Indirect, consequential, or punitive damages</li>
                    <li>Loss of profits or business interruption</li>
                    <li>Damages exceeding the contract value</li>
                    <li>Issues arising from client modifications or misuse</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>8. Confidentiality</h3>
                  <p>We maintain strict confidentiality regarding client information and project details. Both parties agree to protect confidential information disclosed during the course of business.</p>
                </section>

                <section className="legal-section">
                  <h3>9. Termination</h3>
                  <p>Either party may terminate services with written notice as specified in individual contracts. Upon termination:</p>
                  <ul>
                    <li>Payment is due for completed work</li>
                    <li>Confidentiality obligations continue</li>
                    <li>Client materials will be returned</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>10. Governing Law</h3>
                  <p>These terms are governed by the laws of the United Arab Emirates. Any disputes will be resolved through arbitration in Dubai, UAE.</p>
                </section>

                <section className="legal-section">
                  <h3>11. Changes to Terms</h3>
                  <p>We reserve the right to modify these terms at any time. Changes will be effective upon posting on our website. Continued use of our services constitutes acceptance of modified terms.</p>
                </section>

                <section className="legal-section">
                  <h3>12. Contact Information</h3>
                  <p>For questions regarding these terms, please contact us:</p>
                  <div className="contact-info">
                    <p><strong>Email:</strong> legal@efficientgroupdubai.com</p>
                    <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                    <p><strong>Address:</strong> 123 Business District, Dubai, UAE</p>
                  </div>
                </section>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;